import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.75 8a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0M8 1.25a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5m-.728 9.733a.7.7 0 0 0 .7.7h.05a.7.7 0 0 0 .7-.7V7.157a.7.7 0 0 0-.7-.7h-.05a.7.7 0 0 0-.7.7zm.173-5.414q.232.214.555.214t.551-.214a.7.7 0 0 0 .232-.52q0-.3-.232-.514A.77.77 0 0 0 8 4.317a.78.78 0 0 0-.555.218.68.68 0 0 0-.228.513q0 .303.228.52",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }